module.exports = __webpack_public_path__ + "static/media/JBL_Partybox.2b6ccf37.usdz";